export { default } from './src/';



// WEBPACK FOOTER //
// ./index.js